<template>
  <div class="service-item">
    <div class="service-icon">
      <i :class="service.icon"></i>
    </div>
    <div class="service-content">
      <h3>{{ service.title }}</h3>
      <p>{{ service.description }}</p>
      <ul>
        <li v-for="feature in service.features" :key="feature">{{ feature }}</li>
      </ul>
      <router-link 
        v-if="showLearnMore" 
        :to="`/services/${service.id}`" 
        class="read-more">
        Learn More <i class="fas fa-arrow-right"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceCard',
  props: {
    service: {
      type: Object,
      required: true
    },
    showLearnMore: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.service-item {
  display: flex;
  margin-bottom: 40px;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.service-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.service-icon {
  width: 120px;
  background: linear-gradient(135deg, #4dabf7 0%, #1a3a5f 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
}

.service-content {
  padding: 25px;
  flex: 1;
}

.service-content h3 {
  color: #1a3a5f;
  margin-bottom: 15px;
}

.service-content p {
  margin-bottom: 15px;
}

.service-content ul {
  list-style: none;
  margin-top: 15px;
}

.service-content li {
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;
}

.service-content li:before {
  content: "•";
  color: #4dabf7;
  font-weight: bold;
  position: absolute;
  left: 0;
}

.read-more {
  display: inline-block;
  color: #4dabf7;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  margin-top: 15px;
}

@media (max-width: 992px) {
  .service-item {
    flex-direction: column;
  }
  
  .service-icon {
    width: 100%;
    height: 120px;
  }
}
</style>